import { ApolloLink } from '@apollo/client';
import { Observable } from '@apollo/client/utilities';
/**
 * The readable CSRF cookie expires after an hour and only a GET reissues it, so a tab kept open longer would
 * send GraphQL without a token. Renew it before any operation once it is gone; the operation is sent either way.
 */
export function createMissingCsrfRenewLink(options) {
    const { getCookie, csrfCookieName, renewCsrf } = options;
    return new ApolloLink((operation, forward) => {
        if (getCookie(csrfCookieName)) {
            return forward(operation);
        }
        return new Observable(observer => {
            let subscriber;
            let cancelled = false;
            void renewCsrf().finally(() => {
                if (cancelled) {
                    return;
                }
                subscriber = forward(operation).subscribe(observer);
            });
            return () => {
                cancelled = true;
                subscriber?.unsubscribe();
            };
        });
    });
}
//# sourceMappingURL=create-missing-csrf-renew-link.js.map